const jsCopyLink = document.querySelector(".js-copy-link");

if (typeof jsCopyLink != "undefined" && jsCopyLink != null) {

    jsCopyLink.addEventListener("click", (e) => {
        e.preventDefault();

        const linkURl = jsCopyLink.dataset.url;

        navigator.clipboard.writeText(linkURl).then(
            function () {
                // success
                jsCopyLink.innerHTML = "Link copied";
            },
            function (err) {
                //fail
                console.error("Could not copy text: ", err);
            }
        );

    });

}